import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { formatDateRangeCopy } from 'modules/attendance/components/ClockIn/EmployeeTimeTrackingBreakdown/lib/getDateRange'
import MinutesToText from 'modules/attendance/components/MinutesToText'

interface Props {
  balancePoolMinutes: number
  balancePoolCapacity: number
  startOn: string
  endOn: string
}

const Header = ({ balancePoolMinutes, balancePoolCapacity, startOn, endOn }: Props) => {
  const showBalanceLimit =
    balancePoolMinutes > 0 && balancePoolCapacity !== Infinity && balancePoolCapacity !== 0

  return (
    <Box paddingTop="s12" gap="s4">
      <Box>
        <Text size="300" weight="semibold" color="grey1000">
          {i18n.t('clock_in.sidepanel.balance.title')}
        </Text>
        <Box flexDirection="row" gap="s2">
          <Text size="200" weight="medium">
            {`${i18n.t('clock_in.sidepanel.worked_hours.period')}:`}
          </Text>
          <Text size="200" weight="normal">
            {formatDateRangeCopy(startOn, endOn)}
          </Text>
        </Box>
      </Box>

      <Box flexDirection="row" gap="s2">
        <MinutesToText color="grey1000" value={balancePoolMinutes} size="500" weight="medium" />
        {showBalanceLimit && (
          <>
            <Text color="grey800" size="500" weight="medium">
              /
            </Text>
            <MinutesToText color="grey800" value={balancePoolCapacity} size="500" weight="medium" />
          </>
        )}
      </Box>
    </Box>
  )
}

export default Header
